// extracted by mini-css-extract-plugin
export default {"container":"EmiCalculatorAdd_container__JGwRU","bg":"EmiCalculatorAdd_bg__juhry","heading":"EmiCalculatorAdd_heading__wpTxC"};